<template>
  <div class="about">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-7">
        <div class="breadcrumbs">
          <p :lang=selectedLanguageCode>{{ $t('message.you-are-here') }} </p>
          <ul>
            <li>
              <router-link tag="a" to="/">{{ $t('message.LEXIN') }}</router-link>
            </li>
            <li>
              <font-awesome-icon icon="arrow-right" class="right-agap"/>
              <span>{{ $t('message.about') }}</span>
            </li>
          </ul>
        </div>
      </div>
      <Language></Language>
    </div>
    <div class="row om-lexin-padding">
      <div class="col-12">
        <h1>
          <span>{{ $t('message.about') }}</span>
        </h1>
        <div class="clearfix"></div>
        <div class="home-info border-bottom-0 pb-0">
          <p>{{ $t('message.front-page-text-2') }}</p>
          <p><b>{{ $t('message.short-description-4') }}</b></p>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="col-12">
        <div class="home-info">
          <p>{{ $t('message.about-the-project-paragraph-1') }}</p>
          <p>{{ $t('message.about-the-project-paragraph-2') }}</p>
          <p>{{ $t('message.rosing-price') }}</p>
          <h2 class="title">{{ $t('message.earlier-co-workers') }}</h2>
          <ol>
            <li>{{ $t('message.tove-philologist') }}</li>
            <li>{{ $t('message.oystein-programmer') }}</li>
            <li>{{ $t('message.sindre-programmer') }}</li>
            <li>{{ $t('message.paul-programmer') }}</li>
            <li>{{ $t('message.nazareth-translator') }}</li>
            <li>{{ $t('message.vahid-translator') }}</li>
            <li>{{ $t('message.hale-translator') }}</li>
            <li>{{ $t('message.marianne-translator') }}</li>
            <li>{{ $t('message.kjersti-translator') }}</li>
            <li>{{ $t('message.ramin-translator') }}</li>
            <li>{{ $t('message.amor-translator') }}</li>
            <li>{{ $t('message.eva-translator') }}</li>
            <li>{{ $t('message.valentina-translator') }}</li>
            <li>{{ $t('message.osman-translator') }}</li>
            <li>{{ $t('message.nezar-translator') }}</li>
            <li>{{ $t('message.kai-translator') }}</li>
            <li>{{ $t('message.ampai-translator') }}</li>
            <li>{{ $t('message.gerd-translator') }}</li>
            <li>{{ $t('message.bewar-translator') }}</li>
            <li>{{ $t('message.rune-consultant') }}</li>
            <li>{{ $t('message.anne-consultant') }}</li>
            <li>{{ $t('message.hema-translator') }}</li>
            <li>{{ $t('message.mojgan-translator') }}</li>
            <li>{{ $t('message.odd-kjetil-translator') }}</li>
            <li>{{ $t('message.lidia-translator') }}</li>
            <li>{{ $t('message.salar-translator') }}</li>
            <li>{{ $t('message.shagufta-translator') }}</li>
            <li>{{ $t('message.phi-translator') }}</li>
            <li>{{ $t('message.dhayalan-translator') }}</li>
            <li>{{ $t('message.mikucionis-translator') }}</li>
            <li>{{ $t('message.maung-translator') }}</li>
          </ol>
          <h2 class="title">{{ $t('message.norwegian-ukrainian-dictionary') }}</h2>
            <p>{{ $t('message.norwegian-ukrainian-dictionary-intro') }}</p>
          <ol>
            <li>{{ $t('message.andrii-gelyi-translator-and-editor') }}</li>
            <li>{{ $t('message.kateryna-yevseichyk-translator-and-editor') }}</li>
            <li>{{ $t('message.Khrystyna Hole, translator') }}</li>
            <li>{{ $t('message.lilia-grube-editor') }}</li>
            <li>{{ $t('message.marianna-gora-translator') }}</li>
            <li>{{ $t('message.olesya-cherkes-translator-and-editor') }}</li>
            <li>{{ $t('message.tetyana-tkachenko-translator') }}</li>
          </ol>
          <h2>{{ $t('message.nordic-cooperation') }}</h2>
          <p>{{ $t('message.nordic-cooperation-paragraph-1') }}</p>
          <p>{{ $t('message.nordic-cooperation-paragraph-2') }}</p>
          <p>{{ $t('message.nordic-cooperation-paragraph-3') }}</p>
          <p>{{ $t('message.nordic-cooperation-paragraph-4') }}</p>
          <p>
            {{ $t('message.go-to') }} <a target="_blank" href="http://lexin.nada.kth.se/">{{ $t('message.homepage-swedish') }}</a>
          </p>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>

  </div>
</template>

<script>
import Language from "./Language.vue";
export default {
  name: "AboutComponent",
  data() {
     return {
       languageCodeList:[
        {lang:'eng',langISOCode:'en'},
        {lang:'nny',langISOCode:'nn'},
        {lang:'nbo',langISOCode:'nb'}
      ]
    }
  },
  computed: {
    selectedLanguageCode () {
      return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
    },
  },
  components: {
    Language
  },
  created() {
    $("body,html").animate(
      {
        scrollTop: 0
      },
      60
    );
  }
};
</script>
